import { z } from 'zod';

import { BaseLoanEvent } from './BaseLoanEvent';

export const SendFirstArmRateChangeNotificationEvent = BaseLoanEvent.extend({
  type: z.literal('sendFirstArmRateChangeNotification'),
});
export type SendFirstArmRateChangeNotificationEvent = z.infer<typeof SendFirstArmRateChangeNotificationEvent>;
